import * as R from 'ramda'
import React from 'react'
import styled, { css } from 'styled-components'

import AlertSvg from '../../public/static/images/icon-alert.svg'
import { getColor, getFontSize } from '../../utils/cssUtils'
import SvgIcon from '../SvgIcon'

const Alert = styled.div`
  position: relative;
  border-radius: 4px;
  padding: 10px 16px;
  color: ${getColor('theme')};
  font-size: ${getFontSize('body2')};
  background-color: transparent;
  overflow: hidden;
  &::after {
    content: '';
    display: block;
    background-color: ${getColor('theme')};
    opacity: 0.1;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  > p:last-of-type {
    margin-bottom: 0;
  }
  ${({ showIcon }) =>
    showIcon &&
    css`
      display: flex;
      flex-flow: row nowrap;
    `}
`
const AlertText = styled.p`
  &:last-of-type {
    margin-bottom: 0;
  }
`
const IconContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin-right: 8px;
  &:after {
    content: '';
    flex-basis: calc(100% - 2em * 1.5);
  }
`
const StyledSvgIcon = styled(SvgIcon)`
  display: inline-flex;
  flex-grow: 1;
`

export default ({ msg, showIcon = true, children, ...props }) => {
  const renderMsg = () =>
    R.type(msg) === 'Array' ? (
      R.addIndex(R.map)((msg, i) => <AlertText key={i}>{msg}</AlertText>, msg)
    ) : (
      <AlertText>{msg}</AlertText>
    )
  return (
    <Alert {...props} showIcon={showIcon}>
      {showIcon && (
        <IconContainer>
          <StyledSvgIcon svg={<AlertSvg />} />
        </IconContainer>
      )}
      {children || renderMsg()}
    </Alert>
  )
}
